/* Project Import will be here */
import { post, IRequest } from "./index";
/* Project Import will be here */

/* Get unpaid invoice list and information */
export const getDigitalContentListApi = () => {
    const request: IRequest = {subUrl: `/Product/DigitalContent`};
    return post(request);
};